<template>
  <ValidationObserver ref="observer" class="transition duration-500 ease-in-out transform w-full"
                      style="transition: all 1s !important"
                      tag="form" @submit.prevent="submit()">
    <div class="w-full flex py-5 px-5">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="bg-gray-200 pl-4 p-1">
          <span class="flex justify-between w-full text-grey p-2">
            <span class="font-semibold text-base tracking-tight">CPD Activity Information</span>
          </span>
        </div>

        <div class="flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full md:w-1/2 px-3 pt-3 md:mb-0 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">CPD Activity Type:</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.programTypeId" :clearable="clearable" :elevation="1" :items="PROGRAM_TYPES"
                        :loading="programTypeLoading" :searchable="searchable" dense item-text="name" item-value="id"
                        label="cpd activity types" solo></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="showTrainingModality" class="w-full md:w-1/2 px-3 pt-3 md:mb-0 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">CPD Activity:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.categoryId" :clearable="clearable" :elevation="1" :items="CATEGORIES"
                        :loading="cpdActivityLoading" :searchable="searchable" dense item-text="name" item-value="id"
                        label="cpd activity" solo></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="showCourses" class="w-full md:w-1/2 px-3 md:mb-0">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Course Title</label>
            <v-autocomplete v-model="formValues.course" :clearable="clearable" :items="COURSES"
                            :loading="coursesLoading" :searchable="searchable"
                            class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " item-text="courseName" return-object>
            </v-autocomplete>

            <br/>
          </div>

          <div v-if="showCoursesText" class="w-full md:w-1/2 px-3 mb-6">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Course Title</label>
            <input id="courseTitle" v-model="formValues.courseTitleCat2" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " name placeholder="Activity Title"
                   type="text"/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">CEU:
            </label>
            <validation-provider v-slot="{ errors }" rules="required|min_value:0|max_value:15">
              <input id="ceu" v-model="formValues.ceu" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                "
                     :disabled="courseCat == `CAT1`"
                     name placeholder="CEU" type="number"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div v-if="showCeu" class="w-full md:w-1/2 px-3 pt-3 mb-6 required">
            <label class="
                  block
                  uppercase
                  tracking-wide
                  text-gray-700 text-xs
                  font-bold
                  mb-2
                ">Course Level</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.courseLevelId" :clearable="clearable" :elevation="1" :items="COURSE_LEVELS"
                        :loading="courseLevelLoading" :searchable="searchable" dense item-text="name" item-value="id"
                        label="course levels" solo></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div v-if="showCeu" class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Passing Score:
            </label>
            <validation-provider v-slot="{ errors }" rules="required|min_value:0|max_value:100">
              <input id="cat2PassingScore" v-model="formValues.cat2PassingScore" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " name placeholder="passing score"
                     type="number"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div v-if="showCourseLevel" class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Course Level:
            </label>
            <input id="ceu" v-model="courseLevelValue" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " disabled placeholder="Course Level"
                   type="text"
            />
          </div>
          <div v-if="showPassingScore" class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Passing Score:
            </label>
            <input id="cat2PassingScore" v-model="passingScoreValue" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " disabled placeholder="passing score"
                   type="number"/>
          </div>
          <div class="w-full md:w-1/2 px-3 pt-3 md:mb-0">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">CPD Provider</label>
            <v-autocomplete v-model="formValues.cpdProviderId" :clearable="clearable" :elevation="1"
                            :items="CPD_PROVIDERS"
                            :loading="cpdProviderLoading" :searchable="searchable" dense item-text="trainingCenterName"
                            item-value="id"
                            label="cpd providers" solo
                            :disabled="formValues?.cpdProviderId ?? false"
            ></v-autocomplete>
            <br/>
          </div>
          <div v-if="showActivityDelivery" class="w-full md:w-1/2 px-3 pt-3 md:mb-0">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Activity Delivery Modality</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.activityDeliveryId" :clearable="clearable" :elevation="1"
                        :items="ACTIVITY_DELIVERIES"
                        :loading="activityDelivLoading" :searchable="searchable" dense item-text="name"
                        item-value="id"
                        label="activity delivery modalities" solo></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="bg-gray-200 pl-4 p-1">
          <span class="flex justify-between w-full text-grey p-2">
            <span class="font-semibold text-base tracking-tight">Activity Information</span>
          </span>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Facilitated By</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <input id="facilitatedby" v-model="formValues.facilitatedBy" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " name placeholder="facilitated by"
                     type="text"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Participants Number</label>
            <validation-provider v-slot="{ errors }" rules="required|min_value:1">
              <input id="participantsNumber" v-model="formValues.participantsNumber" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " name
                     placeholder="participants number(only numeric values)" type="number"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="showTrainersNumber" class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Trainers Number</label>
<!--            <validation-provider v-slot="{ errors }" rules="required|min_value:1">-->
              <input id="trainersNumber" v-model="formValues.trainersNumber" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " name
                     placeholder="trainers number(only numeric values)" type="number"/>
<!--              <span class="text-gray-600 text-xs italic text-red-700">{{-->
<!--                  errors[0]-->
<!--                }}</span>-->
<!--            </validation-provider>-->
            <br/>
          </div>
        </div>

        <div class="bg-gray-200 pl-4 p-1">
          <span class="flex justify-between w-full text-grey p-2">
            <span class="font-semibold text-base tracking-tight">Activity Duration</span>
          </span>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Start Date</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" max-width="290px"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="formValues.startDate" :clearable="true" label="Pick start date"
                                persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    ref="startDate" v-model="formValues.startDate"
                    :max="formValues.endDate ? formValues.endDate : null" no-title scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">End Date</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" :return-value.sync="date"
                      min-width="290px" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="formValues.endDate" :clearable="true" label="Pick end date"
                                prepend-icon="event"
                                readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker
                    v-model="formValues.endDate" :min="formValues.startDate" no-title
                    scrollable @input="endMenu = false"
                ></v-date-picker>
              </v-menu>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>

        </div>

        <div class="bg-gray-200 pl-4 p-1">
          <span class="flex justify-between w-full text-grey p-2">
            <span class="font-semibold text-base tracking-tight">Program Event Information</span>
          </span>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">

          <div class="w-full md:w-1/2 px-3 mb-6" required>
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Pick event color</label>
            <validation-provider v-slot="{ errors }" rules="required|color:#131414FF">
              <v-text-field v-model="color" class="ma-0 pa-0" hide-details solo>
                <template v-slot:append>
                  <v-menu v-model="colorMenu" :close-on-content-click="false" nudge-bottom="105" nudge-left="16" top>
                    <template v-slot:activator="{ on }">
                      <div :style="swatchStyle" v-on="on"/>
                    </template>
                    <v-card>
                      <v-card-text class="pa-0">
                        <v-color-picker v-model="color" flat/>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
              </v-text-field>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Expected Outcome</label>
            <validation-provider v-slot="{ errors }">
              <textarea v-model="eventData.expectedOutcome" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " placeholder="Enter Expected Outcome." rows="3"></textarea>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Actual Outcome</label>
            <validation-provider v-slot="{ errors }">
              <textarea v-model="eventData.actualOutcome" :disabled="!showActualOutcome" class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                " placeholder="Enter Actual Outcome."
                        rows="3"></textarea>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 mb-0 required">
            <label class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              ">Funded By:</label>
            <validation-provider v-slot="{ errors }" rules="required">
              <select v-model="eventData.fundedById" class="
                  minimal
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none
                  focus:shadow-outline
                ">
                <option v-for="item in FUNDED_BY" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Estimated Cost:
            </label>
            <validation-provider v-slot="{ errors }" rules="required|min_value:0">
              <input
                  id="totalCost"
                  v-model="eventData.totalCost"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name placeholder="Total cost" type="number"/>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Collaborator:</label>
            <input
                id="totalCost"
                v-model="formValues.collaborator"
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="collaborators" type="text"/>
          </div>
        </div>

        <div class="flex flex-wrap my-6 mx-6 mb-6">
          <div class="w-full">
            <button class="
                float-right
                shadow
                bg-teal-600
                hover:bg-teal-600
                focus:shadow-outline
                focus:outline-none
                text-white
                font-bold
                py-2
                px-4
                rounded
              " type="button" @click="submit()">
              {{
                formValues.editMode ? "Update CPD Activity" : "Add CPD Activity"
              }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {
  getActivityDeliveries,
  getCategories,
  getCourseLevel,
  getCourses,
  getFoundedBy,
  getProgramTypes, getUser
} from "@/utils/helper";

import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {max_value, min_value, required} from "vee-validate/dist/rules";
import {TrainingCenterService} from '../TrainingCenter/training_center.service'
import {ProgramEventService} from "./../ProgramEvents/programevent.service";

extend("required", {
  ...required,
  message: "This field is required",
});

extend('color', {
  params: ['target'],
  validate(value, {target}) {
    return value !== target;
  },
  message: 'Invalid Color'
});
extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});
extend("max_value", {
  ...max_value,
  message: "Invalid Value",
});

export default {
  props: ["program", "changeProgramTypeNo", "changeCategoryNo"],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        cpdActivityTitle: "",
        cpdProviderId: null,
        programTypeId: "",
        facilitatedBy: "",
        participantsNumber: "",
        trainersNumber: 0,
        categoryId: null,
        startDate: "",
        endDate: "",
        trainingTitle: "",
        activityDeliveryId: null,
        editMode: false,
        course: null,
        courseTitleCat2: "",
        ceu: null,
        cat2PassingScore: 0,
        collaborator: "",
        courseLevelId: null,
      },
      eventData: {
        start: null,
        end: null,
        programId: null,
        trainingCenterId: null,
        color: null,
        expectedOutcome: null,
        actualOutcome: null,
        totalCost: 0,
        fundedById: null,
        editMode: false,
      },
      color: "#131414FF",
      showProgress: false,
      PROGRAM_TYPES: [],
      COURSES: [],
      showTrainingModality: false,
      CATEGORIES: [],
      date: new Date().toISOString().substr(0, 10),
      ACTIVITY_DELIVERIES: [],
      showCourses: false,
      showCoursesText: false,
      showCeu: false,
      showCourseLevel: false,
      showPassingScore: false,
      showTrainersNumber: false,
      courseLevelValue: "",
      passingScoreValue: "",
      // showTrainingLevel: false,
      showActivityDelivery: false,
      startMenu: false,
      endMenu: false,
      modal: false,
      min: "",
      max: "",
      mutableProgramTypeNo: this.changeProgramTypeNo,
      mutableCategoryNo: this.changeCategoryNo,
      CPD_PROVIDERS: [],
      programTypeLoading: false,
      clearable: true,
      searchable: true,
      cpdActivityLoading: false,
      coursesLoading: false,
      cpdProviderLoading: false,
      activityDelivLoading: false,
      colorMenu: false,
      showActualOutcome: false,
      FUNDED_BY: [],

      COURSE_LEVELS: [],
      courseLevelLoading: false,
      courseCat:null,
    };
  },
  async beforeMount() {
    this.FUNDED_BY = await getFoundedBy();
  },
  computed: {
    swatchStyle() {
      const {color, colorMenu} = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: colorMenu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },
  async created() {
    await this.initiateLookups();
    this.COURSE_LEVELS = await getCourseLevel();
    if (this.program != null) {
      this.formValues = this.program;
      if (this.program.program_courses.length > 0) {
        this.formValues.course = this.program.program_courses[0].course
      }

      this.formValues.editMode = true;
      const res = await ProgramEventService.getEventByCPDActivity(
          this.formValues.id ? this.formValues.id : null,
      );

      if (res.status === 200) {
        this.loading = false;
        this.color = res.data[0].color
        this.eventData = res.data[0];
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Event, Please try Again!"
        );
      }
    }
  },
  methods: {
    async initiateLookups() {
      this.programTypeLoading = true;
      this.cpdActivityLoading = true;
      this.coursesLoading = true;
      this.cpdProviderLoading = true;
      this.activityDelivLoading = true;
      this.PROGRAM_TYPES = await getProgramTypes();
      this.programTypeLoading = false;
      this.COURSES = await getCourses();
      this.coursesLoading = false;
      this.CATEGORIES = await getCategories();
      this.cpdActivityLoading = false;
      this.ACTIVITY_DELIVERIES = await getActivityDeliveries();
      this.activityDelivLoading = false;
      const cpdResponse = await TrainingCenterService.getAllTrainingCenters();
      this.CPD_PROVIDERS = cpdResponse.data.rows.filter((data) => {
        return data.isActive == true;
      });
      this.cpdProviderLoading = false;

      const user = getUser();
      this.formValues.cpdProviderId = this.formValues.cpdProviderId ?? user.data.cpdProviderId;
    },
    async submit() {

      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.prepareEventData();
      this.formValues.event = this.eventData;

      this.$emit("registerOrUpdateProgram", this.formValues);

    },
    prepareEventData() {
      this.eventData.color = this.color;
      this.eventData.start = this.formValues.startDate;
      this.eventData.end = this.formValues.endDate;
      this.eventData.trainingCenterId = this.formValues.cpdProviderId;
    }
  },
  watch: {
    "formValues.programTypeId": function (newValue) {
      this.showCourses = false;
      this.showCoursesText = false;
      this.showCeu = false;

      this.formValues.categoryId =
          this.mutableProgramTypeNo === 0 ? this.formValues.categoryId : null;

      if (newValue === 2) {
        this.showTrainingModality = true;
      } else {
        this.showTrainingModality = false;
      }

      this.mutableProgramTypeNo++;
    },
    "formValues.categoryId": async function (newValue) {
      if (this.mutableCategoryNo > 0) {
        this.formValues.courseTitleCat2 = "";
        this.formValues.course = null;
        this.formValues.cpdProviderId = null;
        this.formValues.ceu = null;
        this.formValues.activityDeliveryId = null;
      }

      const selectedCategory =
          this.CATEGORIES.length !== 0
              ? this.CATEGORIES.filter((data) => {
                return data.id === newValue;
              })
              : null;

      this.courseCat =
          selectedCategory.length !== 0 ? selectedCategory[0].categoryType : null;

      if (this.courseCat === "CAT1") {
        this.showCourses = true;
        this.showCoursesText = false;
        this.showCeu = false;
        this.showTrainersNumber = true;
        this.showActivityDelivery = true;

      } else if (this.courseCat === "CAT2") {
        this.showCourses = false;
        this.showCoursesText = true;
        this.showTrainersNumber = false;
        this.showActivityDelivery = false;

      } else {
        this.showCourses = false;
        this.showCoursesText = false;
        this.showCeu = false;

      }

      this.mutableCategoryNo++;
    },
    "formValues.course": function (course) {
      if (course) {
        this.showCourseLevel = true;
        this.showPassingScore = true;
        this.courseLevelValue = course?.courseLevel?.name;
        this.passingScoreValue = course?.passingScore;
        this.formValues.ceu = course?.continualEducationUnit;
      }
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
